import React from "react";
import Select, { transformDataToSelectOption, SelectProps } from "@/components/atoms/Select";
import { useTranslation } from "react-i18next";
import UserRoleTypeEnum from "@/constants/enums/UserRoleTypeEnum";

const SelectRoleTypeType: React.FC<SelectProps> = (props) => {
  const { t } = useTranslation();

  const options = Object.values(UserRoleTypeEnum).map((role) => role);

  return (
    <Select
      data={transformDataToSelectOption(options, "", "", t, "enumerables:userRoles")}
      loading={false}
      {...props}
    />
  );
};

export default SelectRoleTypeType;
